module.exports = __webpack_public_path__ + "static/media/pm.1888cc34.png";